import { Helmet } from "react-helmet-async";

const SITE_URL = "https://elloGovna.com";
const DEFAULT_IMAGE = `${SITE_URL}/eG-landing.png`;

export default function SEO({ title, description, path = "/", image = DEFAULT_IMAGE, noindex = false, jsonLd }) {
    const url = `${SITE_URL}${path}`;

    return (
        <Helmet>
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
            <link rel="canonical" href={url} />
            <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

            <meta property="og:title" content={title} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:type" content="website" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={image} />

            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
}
